<template>
    <div>
        <el-form :inline="true" ref="searchForm" :model="searchForm" class="forTbFilter" @submit.native.prevent>
            <el-form-item label="套餐组名称：">
                <el-input v-model.trim="searchForm.name" clearable></el-input>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getPkgGroupListPageHandle">搜索</el-button>
                <el-button type="primary" @click="showAddPkgGroup">新建组</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border  >
            <el-table-column prop="name" label="套餐组名称"></el-table-column> 
    <!--    <el-table-column prop="typeName" label="套餐组类型"></el-table-column> -->
            <el-table-column prop="isNextMonthName" label="跨月类型"></el-table-column>  
            <el-table-column prop="supplierTypeName" label="所属类别"></el-table-column> 
            <el-table-column prop="createTime" label="创建时间"></el-table-column> 
            <el-table-column prop="stateName" label="状态"></el-table-column> 
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="showEditPkgGroup(scope.row)">编辑</el-button>
                    <el-button type="text" size="small" @click="sharePkgGroup1(scope.row)">宣传图</el-button>
                    <el-button type="text" size="small" @click="changeStateHandle(scope.row.id)">{{ showbtnText(scope.row.state) }}</el-button>
                </template>    
            </el-table-column> 
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>  
        <el-dialog :append-to-body="true"  :title="title" :visible.sync="addGroupVisibale" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="addOrEditGroupForm" :model="addOrEditGroupForm" :rules="addOrEditGroupRules" label-width="120px">
                <el-form-item label="套餐组名称：" prop="name">
                    <el-input v-model.trim="addOrEditGroupForm.name" clearable></el-input>
                </el-form-item>    
<!--                 <el-form-item label="套餐类型：" prop="type">
                      <el-select v-model="addOrEditGroupForm.type" placeholder="请选择">
                        <el-option v-for="item in pkgTypeOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                    </el-select>
                </el-form-item>  -->

                <el-form-item label="是否跨月：" prop="isNextMonth">
                      <el-select v-model="addOrEditGroupForm.isNextMonth" placeholder="请选择">
                        <el-option v-for="item in isMonthOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                    </el-select>
                </el-form-item>   
                <el-form-item label="所属类别：" prop="supplierType">
                      <el-select v-model="addOrEditGroupForm.supplierType" placeholder="请选择">
                        <el-option v-for="item in supplierOption" :value="item.code" :key="item.description" :label="item.description"></el-option>
                    </el-select>
                </el-form-item>    

                <el-form-item label="用微信支付：" prop="payType">
                    <el-radio-group v-model="addOrEditGroupForm.payType">
                        <el-radio :label="0">否</el-radio>
                        <el-radio :label="20">是</el-radio>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="备注：" prop="remark">
                    <el-input v-model.trim="addOrEditGroupForm.remark" clearable></el-input>
                </el-form-item> 

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="addOrEidtGroupHandle">确 定</el-button>
            </div>            
        </el-dialog>  





          <el-dialog
      :append-to-body="true"
      class="formDialog"
      :title="title"
      :visible.sync="shareGroup1"
      width="600px"
      @close="cancel12"
      :close-on-click-modal="false"
    >
      <el-form ref="searchForm" :model="searchForm" label-width="120px">
        <el-form-item label="宣传图：">
          <input type="file" ref="file2" placeholder="必选" />
          <img
            :src="getImgUrl() + searchForm.imgUrl"
            alt=""
            width="150"
            height="150"
          />
        </el-form-item>
        <el-form-item label="活动金额：" prop="payPrice">
          <el-input
            v-model.trim="searchForm.payPrice"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel12">取 消</el-button>
        <el-button type="primary" @click="addOrEidtPkgHandle1">确 定</el-button>
      </div>
    </el-dialog>



    </div>
</template>
<script>
import {getPkgGroupListPage,addPkgGroup,updatePkgGroup,changePkgGroupState, getPkgIsMonthOption} from '@/api/package.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            existBackImg1:false,
            shareGroup1:false,
            searchForm: {
                payPrice:'',
                imgUrl:'',
                name: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0,                
            },            
            addOrEditGroupForm: {
                name: '',
                type: '',
                isNextMonth: '',
                supplierType: '',
                payType:'',
                remark:'',
            },
            currentId: '',
            addFlag: null,
            addGroupVisibale: false,
            title: '',
            pkgTypeOption: [],
            supplierOption: [],
            isMonthOption: [],
            addOrEditGroupRules: {
                name: [{required: true, message: '请输入套餐名称', trigger: 'blur'}],
                type: [{required: true, message: '请选择套餐名称', trigger: 'change'}],
                isNextMonth: [{required: true, message: '请选择套餐名称', trigger: 'change'}],
                supplierType: [{required: true, message: '请选择套餐名称', trigger: 'change'}]
            }
        }
    },
    methods: {
         addOrEidtPkgHandle1() {
      let fd = new FormData();
      Object.keys(this.searchForm).forEach((key) => {
        fd.append(key, this.searchForm[key]);
      });
      fd.append("title", this.$refs.file2.files[0]);

      common
        .sysRequest("pkg/group/insert/price/img", fd, "post")
        .then((res) => {
          if (res.data.code == 200) {
            this.$refs.file2.value = "";
            this.searchForm.id="";
            this.$message.success(res.data.message);
            this.getPkgGroupListPageHandle();
            callback(res);
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((err) => console.error(err));

      var _this = this;
      function callback(res) {
        if (res.data.code == 200) {
          _this.shareGroup1 = false;
        } else {
          _this.$message.error(res.data.message);
        }
      }
    },
    sharePkgGroup1(row) {
      this.searchForm.id = row.id;
      this.searchForm.payPrice=row.payPrice;
      this.searchForm.imgUrl = row.imgUrl;
      this.existBackImg1 = true;
      this.shareGroup1 = true;
    },
    cancel12(){
    this.existBackImg1 = false;
      this.shareGroup1 = false;
    },





        cancel(){
            this.addGroupVisibale = false;      
            this.$refs.addOrEditGroupForm.resetFields();    
        },   
        showbtnText(state){
            return common.showTxtByState(state, {0: '启用', 1: '禁用'})
        },
        getPkgGroupListPageHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);  
            getPkgGroupListPage(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            }) 
        },
        showAddPkgGroup(){
            this.addGroupVisibale = true;
            this.addFlag = true;
            this.title = "新增套餐组";             
            this.addOrEditGroupForm = this.$data.addOrEditGroupForm;
        },
        showEditPkgGroup(row){
            this.addGroupVisibale = true;
            this.addFlag = false;
            this.title = "修改套餐组";
            this.addOrEditGroupForm.payType = row.payType;
            this.addOrEditGroupForm.remark = row.remark;
            this.addOrEditGroupForm.name = row.name;
            this.addOrEditGroupForm.type = row.type;
            this.addOrEditGroupForm.isNextMonth = row.isNextMonth;
            this.addOrEditGroupForm.supplierType = row.supplierType;
            this.currentId = row.id; 
        },
        addOrEidtGroupHandle(){
            this.$refs.addOrEditGroupForm.validate(valid => {
                if(valid) {
                    var data = this.addOrEditGroupForm;
                    if(this.addFlag == true){
                        addPkgGroup(data).then(res => callback(res))
                    }else{
                        data.id = this.currentId
                        updatePkgGroup(data).then(res => callback(res))               
                    }                    
                }
                var _this = this;
                function callback(res){
                    if(res.data.code == 200){
                        _this.getPkgGroupListPageHandle();
                        _this.addGroupVisibale = false;
                        
                    }else{
                        _this.$message.error(res.data.message)
                    }                     
                }
            }) 
        },
        changeStateHandle(id){
            var data = {
                id
            }
            changePkgGroupState(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message)
                    this.getPkgGroupListPageHandle();
                }else{
                    this.$message.error(res.data.message);
                }
            })           
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getPkgGroupListPageHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val
            this.getPkgGroupListPageHandle();
        }  
    },
    created () {
        this.getPkgGroupListPageHandle();
        common.getPkgTypeOptionCom(this, 'pkgTypeOption');
        common.getSupplierOptionCom(this, 'supplierOption');
        getPkgIsMonthOption().then(res => {
            if(res.data.code == 200){
                this.isMonthOption = res.data.data;
            }else{
                this.$message.error(res.data.message);
            }            
        })
    }    
}
</script>
<style>

</style>
